(function () {
  'use strict';

  /* ---------- Menú móvil ---------- */
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Contador del carrito ---------- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }
  refreshCartCount();

  /* ---------- Ficha de producto ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var variantsEl = root.querySelector('[data-variants]');
    if (!variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent);
    var addButtons = document.querySelectorAll('[data-add-to-cart]');
    var buyNow = root.querySelector('[data-buy-now]');
    var sticky = document.querySelector('[data-sticky-bar]');
    var priceTargets = root.querySelectorAll('[data-pack-price]');

    function findVariant(opts) {
      if (!opts.length) return variants[0];
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (variants[i].options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    function unitVariant(unit) {
      var selects = unit.querySelectorAll('select');
      var opts = [];
      selects.forEach(function (s) { opts.push(s.value); });
      return findVariant(opts);
    }

    function currentUnits() {
      var checked = root.querySelector('input[name="pack"]:checked');
      if (!checked) return [];
      return checked.closest('.pack').querySelectorAll('.unit');
    }

    function showMedia(id) {
      var found = false;
      root.querySelectorAll('[data-media-id]').forEach(function (el) {
        if (el.classList.contains('gallery__thumb')) {
          el.classList.toggle('is-active', el.getAttribute('data-media-id') === String(id));
        } else {
          var match = el.getAttribute('data-media-id') === String(id);
          el.classList.toggle('is-active', match);
          if (match) found = true;
        }
      });
      return found;
    }

    function update() {
      var units = currentUnits();
      var ok = units.length > 0;
      units.forEach(function (u) {
        var v = unitVariant(u);
        if (!v || !v.available) ok = false;
      });
      addButtons.forEach(function (b) {
        b.disabled = !ok;
        b.textContent = ok ? b.getAttribute('data-label') : 'Agotado';
      });
      if (buyNow) buyNow.disabled = !ok;
    }

    function add(goCheckout) {
      var items = [];
      currentUnits().forEach(function (u) {
        var v = unitVariant(u);
        if (!v) return;
        var existing = items.filter(function (i) { return i.id === v.id; })[0];
        if (existing) existing.quantity += 1;
        else items.push({ id: v.id, quantity: 1 });
      });
      if (!items.length) return;
      addButtons.forEach(function (b) { b.disabled = true; });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { if (goCheckout) { window.location.href = '/checkout'; } else if (window.KCDrawer) { KCDrawer.open(); update(); } else { window.location.href = '/cart'; } })
        .catch(function () {
          alert('No se ha podido añadir al carrito. Revisa la disponibilidad de la talla y el color.');
          update();
        });
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('select') || t.name === 'pack') {
        update();
        var first = currentUnits()[0];
        if (first) {
          var v = unitVariant(first);
          if (v && v.media) showMedia(v.media);
        }
      }
    });

    root.querySelectorAll('.gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(thumb.getAttribute('data-media-id'));
      });
    });

    addButtons.forEach(function (b) {
      b.addEventListener('click', function () { add(false); });
    });
    if (buyNow) buyNow.addEventListener('click', function () { add(true); });

    /* Barra fija inferior */
    var mainBtn = root.querySelector('[data-add-to-cart]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var below = entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', !entry.isIntersecting && below);
        });
      });
      io.observe(mainBtn);
    }

    update();
  });
})();
